import { store } from 'store/store';
import { push } from 'connected-react-router';
import * as checkUrl from 'utils/checkUrl';
import getAuthToken from 'utils/getAuthToken';
import resolvePath from 'utils/resolvePath';
import * as WebSocketClient from 'utils/WebSocketClient';
export default () => {
    window.addEventListener('online', () => recoverWebSocket());
    document.addEventListener('visibilitychange', () => refreshConnection());
};
const refreshConnection = () => {
    const state = document.visibilityState;
    if (state === 'visible') {
        recoverWebSocket();
        recoverSignedIn();
    }
};
const recoverWebSocket = () => {
    WebSocketClient.reconnect();
};
const recoverSignedIn = () => {
    const authToken = getAuthToken();
    if (checkUrl.isSignedOutPage() && authToken) {
        if (checkUrl.shouldMoveToTeachersMyPage()) {
            store.dispatch(push(resolvePath.page('teachers', 'mypage')));
        }
        else if (checkUrl.shouldMoveToStudentsMyPage()) {
            location.href = '/sessions/jump';
        }
    }
};
